export default "__VITE_ASSET__bAalfaUs__"